import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

/**
 * Modal for configuring consent types
 */
const ConsentModal = ({ open, onClose, onSubmit, modalState, onStateChange }) => {
  const { consentType } = modalState;

  const handleSubmit = () => {
    if (consentType.trim()) {
      onSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Configure Consent Type</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Consent Type"
          fullWidth
          variant="outlined"
          value={consentType}
          onChange={(e) => onStateChange("consentType", e.target.value)}
          placeholder="marketing"
          helperText="Enter the consent type (e.g., marketing, analytics, functional)"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentModal;
